import modules from "@/store/index.js";
import { analytics } from "@/plugins/firebase.js";
import { handleStatusBar } from "@/plugins/statusbar.plugins.js";
import { handleSplashscreen } from "@/plugins/splashscreen.plugins.js";
import { handleCopyLayer } from "@/plugins/copy.plugins.js";
import router from '@/router/index.js';
import mixin from '@/mixin/index.js';
const { _decrypt } = mixin.methods;
const TAG_SHARE = "/share/";
const root = { root: true };

const getLinkRedirect = to => {
    if (new RegExp(TAG_SHARE).test(to.redirectedFrom)) {
        try {
            const replacedTag = to.redirectedFrom.replace(TAG_SHARE, "");
            localStorage.setItem('link_redirect', replacedTag);
            modules.commit("general/setLinkRedirect", JSON.parse(_decrypt(replacedTag, true)), root);
        } catch {
            removeLinkRedirect();
        }
    }
}

const getLinkRedirectFromDynamicLink = data => {
    modules.commit("general/setLoadingOn", null, root);
    new Promise((resolve, reject) => {
        if (data) {
            let link = data.deepLink;
            if (new RegExp(TAG_SHARE).test(link)) {
                modules.commit("general/setHasDynamicLink", true, root);
                try {
                    link = link.split(TAG_SHARE)[1];
                    const decrypted = JSON.parse(_decrypt(link, true));
                    localStorage.setItem('link_redirect', link);
                    modules.commit("general/setLinkRedirect", decrypted, root);
                } catch (e) {
                    console.log(e);
                    removeLinkRedirect();
                    modules.commit("general/setLoadingOff", null, root);
                }
                resolve();
            }
        }
        modules.commit("general/setLoadingOff", null, root);
        reject();
    }).then(function () {
        setTimeout(function () {
            modules.commit("general/setLoadingOff", null, root);
            router.push(modules.getters['general/link_redirect']);
        }, 300);
    });
}

const removeLinkRedirect = () => {
    localStorage.removeItem('link_redirect');
    modules.commit("general/setLinkRedirect", null, root);
    modules.commit("general/setHasDynamicLink", false, root);
}

const startPlugins = () => {
    if (cordova) {
        cordova.plugins.firebase.dynamiclinks.onDynamicLink(function (data) {
            getLinkRedirectFromDynamicLink(data);
        });
        cordova.plugins.firebase.dynamiclinks.getDynamicLink().then(function (data) {
            getLinkRedirectFromDynamicLink(data);
        });
    }
}

const manageZoom = function (to) {
    let metaTag = "width=device-width,initial-scale=1.0,height=device-height,viewport-fit=cover"
    if (!to.meta.allowZoom) {
        metaTag += ",maximum-scale=1.0,user-scalable=no";
    }
    let el = document.getElementById("vetalfa-viewport-meta");
    el.setAttribute('content', metaTag);
}

const validateScrolling = function (to) {
    if (to.meta.scrolling) {
        document.body.style =
            "overflow:auto!important;position:absolute!important;width:100%;";
        if (to.meta.collapseHeaderOnScroll) {

        }
    } else {
        document.body.style =
            "overflow:hidden!important;position:fixed!important;width:100%;";
    }
}

const redirect = function (from, to, next, user) {
    handleSplashscreen();
    handleStatusBar(to.meta);
    handleCopyLayer(to);
    manageZoom(to);
    validateScrolling(to);

    if (localStorage.getItem('link_redirect')) {
        try {
            let link_redirect = localStorage.getItem('link_redirect');
            link_redirect = JSON.parse(_decrypt(link_redirect, true));
            modules.commit("general/setLinkRedirect", link_redirect, root);
        } catch {
            modules.commit("general/setLinkRedirect", null, root);
        }
    }

    getLinkRedirect(to);
    if (!user && !to.meta.publicPage && to.name !== 'update') {
        if (to.path !== '/login' && !from.params.mode) {
            modules.commit("general/setLinkRedirect", to, root);
        }
        next({ path: '/login' });
    } else if (user && to.name != "questions" && !user.questions && modules.getters['general/fromLogin']) {
        modules.commit("general/setFromLogin", false, root);
        next({ path: '/questions' });
    } else if (modules.getters['general/link_redirect'] && to.name !== 'login' && to.name !== 'questions') {
        modules.commit("general/setLoadingOff", false, root);
        let link_redirect = Object.assign({}, modules.getters['general/link_redirect']);
        const matchingRoutes = from.path == link_redirect.path;
        removeLinkRedirect();
        modules.commit("drugs/setProduct", null, root);
        modules.commit("drugs/setDrug", null, root);
        modules.commit("drugs/setDose", null, root);
        if (matchingRoutes && from.query.title && link_redirect.query.title && link_redirect.query.title == from.query.title) {
            next();
        } else {
            next(link_redirect);
        }
    } else if (user && to.name == "login") {
        next({ path: '/' });
    } else {
        analytics.logEvent('page_view', { 'name': to.name });
        modules.commit("general/setLoadingOff", false, root);
        if (!modules.getters['general/hasDynamicLink']) {
            next();
        }
    }
}

document.addEventListener('deviceready', startPlugins);

export default {
    setUser: function (from, to, next, user) {
        analytics.setUserId(user.uid);
        modules.commit("general/setUser", user, root);
        redirect(from, to, next, user);
    },
    route: function (path, view, meta, component) {
        return {
            name: view.split(/(?=[A-Z])/).join('-').toLowerCase(),
            path,
            component: component,
            props: true,
            meta
        };
    },
    redirect,
    getLinkRedirect,
    getLinkRedirectFromDynamicLink
}